// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.

declare function require(moduleName: string): any;
const { version } = require('../../package.json');

const isProduction = false;

export const environment = {
  configuration: 'dev',
  production: isProduction,
  __DEV__: JSON.stringify(!isProduction),
  __VERSION__: JSON.stringify(version),
  enableServiceWorker: true,
};
